import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getALlowedSections } from "../../controllers/user";

const AuthContext = createContext({
  token: '',
  allowedSections: [],
  onLogin: () => {},
  onLogout: () => {},
});

const useAuth = () => {
  return useContext(AuthContext);
};

const AuthProvider = ({ children }) => {
  const [token, setToken] = useState('');
  const [isTokenExpired, setIsTokenExpired] = useState(false);
  const [allowedSections, setAllowedSections] = useState([]);
  const navigate = useNavigate();

  if (!token) {
    let t = localStorage.getItem('token');
    if (t) {
      const decodedJwt = JSON.parse(atob(t.split(".")[1]));
      if(decodedJwt.exp * 1000 < Date.now()) {
        setIsTokenExpired(true);
        localStorage.removeItem('token');
        localStorage.removeItem('sections');
      }
      else {
        setToken(t);
      }
    }
  }
  
  if (!allowedSections) {
    let s = JSON.parse(localStorage.getItem('sections'));
    if (s) {
      setAllowedSections(s);
    }
  }
  else if (allowedSections && !allowedSections.length) {
    let s = JSON.parse(localStorage.getItem('sections'));
    if (s && JSON.stringify(s) != JSON.stringify(allowedSections)) {
      setAllowedSections(s);
    }
  }

  useEffect(() => {
    localStorage.setItem('token', token);
  }, [token]);
  useEffect(() => {
    console.log('Allowed sections: ', allowedSections);
    localStorage.setItem('sections', JSON.stringify(allowedSections));
  }, [allowedSections]);

  async function loadSections() {
    let s = await getALlowedSections(token);
    setAllowedSections(s);
  }

  const handleLogin = async (data) => {
    setToken(data.token);

    if (data.membership && data.isMembershipComplete && !data.registration) {
      setAllowedSections(data.allowedSections);
      navigate('/app');
    }
    else if (data.membership && !data.isMembershipComplete) {
      console.log('membership', data.membership, data.isMembershipComplete);
      navigate('/registro', { state: {membership: data.membership }} );
      // navigate('/app');
    }
  };

  const handleLogout = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    localStorage.removeItem('token');
    localStorage.removeItem('sections');
    setToken('');
    setAllowedSections([]);
    navigate('/');
  };

  const value = {
    token,
    allowedSections: allowedSections,
    onLogin: handleLogin,
    onLogout: handleLogout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export {
  AuthProvider,
  AuthContext,
  useAuth
};
